import { render, staticRenderFns } from "./SelectedPortfolios.vue?vue&type=template&id=a86cfe52&"
import script from "./SelectedPortfolios.vue?vue&type=script&lang=js&"
export * from "./SelectedPortfolios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports